import { SET_PAYMENT_VIEW } from "../../types";

const setPaymentView = (status) => (dispatch) => {
  dispatch({ type: SET_PAYMENT_VIEW, status });
};

export { setPaymentView };
